import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Workplace } from '../_models/workplace';
import { Position } from '../_models/position';

@Injectable()
export class ConstantsService {
  constructor(private http: HttpClient) {}

  getPositions(): Observable<Position[]> {
    return this.http.get<Position[]>('/api/positions');
  }

  getWorkplaces(): Observable<Workplace[]> {
    return this.http.get<Workplace[]>('/api/workplaces');
  }
}
